import { ParseNode } from '../../Parse/ParseNode';
import { ExprForm } from '../ExprForm';
export var Generic;
(function (Generic) {
    let Parsed;
    (function (Parsed) {
        function make(root) {
            const form = ExprForm.Generic;
            const state = "PARSED";
            return { root, form, state, name: ParseNode.toString(root) };
        }
        Parsed.make = make;
    })(Parsed = Generic.Parsed || (Generic.Parsed = {}));
    let Compiled;
    (function (Compiled) {
        function make(expr, stage, data) {
            const state = "COMPILED";
            switch (stage) {
                case "CONST":
                case "SCALAR":
                    return { ...expr, stage, data, state };
                case "ANALYTIC":
                case "AGGREGATE":
                    return { ...expr, stage, state, data, name: `AGG(${expr.name})` };
            }
        }
        Compiled.make = make;
    })(Compiled = Generic.Compiled || (Generic.Compiled = {}));
})(Generic || (Generic = {}));
